import React from 'react';
import { useForm } from "react-hook-form";
import { match } from 'react-router';
import { loginUser } from '../../store/actions';
import { RouteMatchProps } from '../../types';

import * as S from './style';

interface PopupProps {
    popupVisibility: boolean | undefined;
    setPopupVisibility: (arg: boolean) => void;
    hasWhiteBackground: match<RouteMatchProps> | null;
}

type FormData = {
  username: string;
  password: string;
};

const LoginPopup: React.FC<PopupProps> = ({ popupVisibility, setPopupVisibility, hasWhiteBackground }) => {
    const { register, handleSubmit, errors } = useForm<FormData>();

    const onSubmit =  handleSubmit(({ username, password }) => {
        loginUser(username, password)
        setPopupVisibility(false)
    });

    const closePopup = (e: any) => {
        const target = e.target as HTMLDivElement;
        !target.closest('#popup') ? setPopupVisibility(false) : null
    };

    return (
        <>
            {popupVisibility && (
                <S.LoginPopup onClick={e => closePopup(e)}>
                    <S.PopupWrapper hasWhiteBackground={hasWhiteBackground} id="popup">
                        <button className="close-btn" onClick={() => setPopupVisibility(false)}>
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
                        </button>
                        <S.Form onSubmit={onSubmit}>
                            <div className="username">
                                <label>Username</label>
                                <input ref={register({ required: true })} name="username" type="text"/>
                            </div>
                            {errors.username && <span className="error">&#42; Questo campo è obbligatorio</span>}
                            <div className="password">
                                <label>Password</label>
                                <input ref={register({ required: true })} name="password" type="password"/>
                            </div>
                            {errors.password && <span className="error">&#42; Questo campo è obbligatorio</span>}
                            <button className="login-btn">Login</button>
                        </S.Form>
                    </S.PopupWrapper>
                </S.LoginPopup>
            )}
        </>
    )
}

export default LoginPopup;